import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICON } from '@core/util/icon';

@Component({
	selector: 'app-no-forms-available',
	templateUrl: './no-forms-available.component.html',
	styleUrls: ['./no-forms-available.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class NoFormsAvailableComponent {
	public ICON = ICON;
}
